module.exports = __webpack_public_path__ + "img/building-6.dab06d1a.png";